<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                <h3>All Torah General Donation</h3>
                  <FormSection title="Donation Amount">
                      <FormRow inline>
                            <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
                      </FormRow>                  
                      <div>
                          <AmountSelector defaultCheckedAount="360"/>
                          <ErrorLabel field="amount" />
                          <div class="alltorah__honor">* Join the All Torah, All Year 360 Scroll of Honor</div>
                      </div>
                  </FormSection>
                  <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthlyText="Recurring Monthly Gift" />
            </div>
            <TransactionFee  v-if="form.amount"/>
          </FormSection>
                  <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" label="First Name *" />
              <FormCol field="lastName" :flex="2" label="Last Name *" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" label="Email *" />
              <FormCol field="phone" label="Phone *" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
            <FormRow inline>
              <FormCol field="street" label="Street *" />
              <FormCol field="street2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="city" :flex="2" label="City *" />
              <FormCol field="state" :flex="1" label="State *"><StateSelector :country="form.country" /></FormCol>
              <FormCol field="zip" :flex="1" label="Zip *" />
            </FormRow>
            <FormRow inline>
              <FormCol field="country" width="half"><CountrySelector /></FormCol>
            </FormRow>
            <FormRow>
              <FormLabel>
                <input
                  type="checkbox"
                  id="anonymousCheck"
                  :checked="getValue('custom.anonymous') === 'yes'"
                  @click="setValue('custom.anonymous', $event.target.checked ? 'yes' : 'no')"
                /> I would like my donation to be listed anonymously.
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt :receipts="['us', 'israel', 'canadian']" />
            </FormRow>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
          </div>
      </div>
  </div>
  </template>

  <script lang="ts">
  import { computed, defineComponent, onMounted, watch } from "vue";
  import { usePaymentForm } from "~/shared/use-payment-form";
  import { queryParams } from "~/shared/query-params";

  export default defineComponent({
    setup() {
      const { setValue, getValue, form, testMode } = usePaymentForm();

      onMounted(() => {
        const callbackUrl = testMode
          ? "https://admin-outorah.oudev.org/outorahDonationCallback"
          : "https://admin.outorah.org/outorahDonationCallback";

        console.log("[alltorah-general] testMode:", testMode, "callback:", callbackUrl);

        setValue("callback", callbackUrl);

        setValue("amount", "360");
        setValue("custom.seriesType", "General Donation");
        setValue("custom.programId", null);
        setValue("custom.dafType", null);
      });


    watch(
      () => getValue("custom.dedicationType"),
      (val) => {
        if (val) {
          setValue("custom.dedication", getValue("custom.dedicationType") + " ");
        }
      }
    );


      return {
        getValue,
        form,
        setValue,
      }
    },
  })
  </script>
  <style scoped lang="scss">
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }


.ou-donation-form ::v-deep
  .styled-radio-container.styled-radio-container--ou-donation.row{

    .radio-part{
      @media only screen and (min-width: 720px) {
    min-width: 32% !important;
    max-width: 32% !important;
  }
    }

  }


  h3{
    font-size: 20px;
    text-align: center;
    font-weight: 600;
    padding-bottom: 30px;
    padding-top: 10px;
    @media only screen and (min-width: 720px) {
      font-size: 20px;
    text-align: center;
    font-weight: 600;
    padding-bottom: 30px;
    padding-top: 10px;
    }
  }



  ::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="360"] {
  &:after {
    content: "*";
    font-size: 11px;
    padding-left: 2px;
  }
}

.alltorah__honor{
  font-size: 14px;
  padding-bottom: 15px;
}
  </style>

